export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-chat-1-line text-xl text-white"></i>
                </div>
                <span className="font-heading text-lg text-background-50">51吃瓜爆料网</span>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed mb-4">
                全网最新吃瓜爆料平台。每日更新娱乐圈八卦、网红黑料合集，
                汇总今日热门爆料事件，持续提供娱乐八卦更新与每日爆料汇总。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-base text-background-50"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-base text-background-50"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-global-line text-base text-background-50"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="font-sans font-bold text-sm text-background-50 mb-4">快速导航</h3>
              <div className="space-y-2.5">
                <a href="#carousel" onClick={(e) => handleClick(e, '#carousel')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">焦点爆料</a>
                <a href="#topics" onClick={(e) => handleClick(e, '#topics')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">话题热榜</a>
                <a href="#cards" onClick={(e) => handleClick(e, '#cards')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">深度爆料</a>
                <a href="#ranking" onClick={(e) => handleClick(e, '#ranking')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">热度榜单</a>
                <a href="#updates" onClick={(e) => handleClick(e, '#updates')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">最新快讯</a>
              </div>
            </div>

            <div>
              <h3 className="font-sans font-bold text-sm text-background-50 mb-4">关于我们</h3>
              <div className="space-y-2.5">
                <a href="#about" onClick={(e) => handleClick(e, '#about')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">平台介绍</a>
                <a href="#faq" onClick={(e) => handleClick(e, '#faq')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">常见问答</a>
                <a href="#contact" onClick={(e) => handleClick(e, '#contact')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
                <a href="#app" onClick={(e) => handleClick(e, '#app')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">APP下载</a>
                <a href="#features" onClick={(e) => handleClick(e, '#features')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">平台优势</a>
              </div>
            </div>

            <div>
              <h3 className="font-sans font-bold text-sm text-background-50 mb-4">合作伙伴</h3>
              <p className="text-sm text-foreground-400 leading-relaxed">
                感谢各合作平台的支持与信任。更多合作信息持续更新中。
              </p>
            </div>
          </div>

          <div className="pt-8 border-t border-foreground-800">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                &copy; 2026 51吃瓜爆料网 - 51吃瓜官网全网最新 | 今日热门爆料 | 娱乐八卦更新 | 网红黑料合集 | 每日爆料汇总
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <span className="cursor-pointer hover:text-primary-400 transition-colors">用户协议</span>
                <span className="cursor-pointer hover:text-primary-400 transition-colors">隐私政策</span>
                <span className="cursor-pointer hover:text-primary-400 transition-colors">免责声明</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}